import { Injectable } from '@angular/core';
import { firstValueFrom, map, Observable, catchError, of } from 'rxjs';
import { PQREncargosSociaisDto } from '../../dtos/pqr-encargos-sociais.dto';
import { environment } from '../../../environments/environment';
import { CaqRequestService } from '../'
import { MemoriaDeCalculoRequestDto} from '../../dtos/memoria-calculo-dto'


@Injectable({
  providedIn: 'root',
})
export class PQREncargosSociaisService {

  private apiUrl = `${environment.apiUrl}/pqr`;
  private apiUrlRest = `${environment.apiUrl}/pqr-adicionais-manutencao-encargos`;

  constructor(
    private caqRequestService: CaqRequestService
  ) { }

  buscarListaDePQREncargosSociais(): Observable<PQREncargosSociaisDto[]> {
    return this.caqRequestService
      .get<MemoriaDeCalculoRequestDto>(this.apiUrl)
      .pipe(
        map((response) => {
          try {
            return response.pqrEncargosSociaisList || [];
          } catch (error) {
            console.warn('Erro ao processar dados PQR Direitos e obrigações trabalhista:', error);
            return [];
          }
        }),
        catchError((error) => {
          console.warn('Erro na requisição PQR Direitos e obrigações trabalhista:', error);
          return of([]);
        })
      );
  }

  salvePQREncargosSociais(requisicao: PQREncargosSociaisDto) {
    return firstValueFrom(this.caqRequestService
      .put<PQREncargosSociaisDto>(`${this.apiUrlRest}/${requisicao.codPqrAdicionaisManutencaoEncargos}`, requisicao)
      .pipe(map((response) => response)));
  }
}
